// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"279":"component---src-pages-index-jsx","415":"component---src-pages-404-jsx"}[chunkId] + "-" + {"279":"d10152373e342e79f254","415":"30149a19c77581c751f5"}[chunkId] + ".js";
};